import { render } from "./UclScorers.vue?vue&type=template&id=6e88321e&scoped=true"
import script from "./UclScorers.vue?vue&type=script&lang=js"
export * from "./UclScorers.vue?vue&type=script&lang=js"

import "./UclScorers.vue?vue&type=style&index=0&id=6e88321e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e88321e"]])

export default __exports__